const OutputHTML = (HTMLContent) => {
	return { __html: HTMLContent.concat("") };
}

export default OutputHTML 